import { MapPin } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The wordmark, and optionally the portal it sits in.
 *
 * `subtitle` has **no default** on purpose. It used to be hardcoded to
 * "Admin Portal", which was right in the admin sidebar and wrong everywhere
 * else — employees read "GEOKERJA ADMIN PORTAL" above their own check-in
 * screen, and on the shared sign-in and invitation pages nobody knows yet
 * which lane the visitor belongs to. Omitting it renders the wordmark alone,
 * which is correct in all three of those places; a caller that genuinely knows
 * its lane passes the label.
 */
export function GeoKerjaLogo({
  className,
  variant = "dark",
  subtitle,
}: {
  className?: string;
  variant?: "dark" | "light";
  subtitle?: string;
}) {
  const text = variant === "light" ? "text-white" : "text-foreground";
  const sub = variant === "light" ? "text-white/70" : "text-muted-foreground";
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-primary shadow-glow">
        <MapPin className="h-5 w-5 text-white" strokeWidth={2.5} />
        <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-success ring-2 ring-background" />
      </div>
      <div className="leading-tight">
        <div className={cn("font-display text-base font-bold tracking-tight", text)}>GeoKerja</div>
        {subtitle && (
          <div className={cn("text-[10px] font-medium uppercase tracking-wider", sub)}>
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
}
